import { render, staticRenderFns } from "./AppNotificationBar.vue?vue&type=template&id=451ff3dc&scoped=true&"
import script from "./AppNotificationBar.vue?vue&type=script&lang=ts&"
export * from "./AppNotificationBar.vue?vue&type=script&lang=ts&"
import style0 from "./AppNotificationBar.vue?vue&type=style&index=0&id=451ff3dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451ff3dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAlert,VBtn,VIcon})
